import { type FC } from 'react';

import CloseOutlined from '@mui/icons-material/CloseOutlined';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { IconButton } from '@craft/ui/components/buttons';

import { SearchBar } from '@/src/components/organisms/SearchBar';

import { SearchDialogTitle } from './SearchDialogTitle';

interface SearchDialogProps {
  readonly isOpen: boolean;
  readonly onCancel: () => void;
}

export const SearchDialog: FC<SearchDialogProps> = ({ isOpen, onCancel }) => {
  const handleClose = () => {
    onCancel();
  };

  return (
    <Dialog fullScreen open={isOpen}>
      <SearchDialogTitle>
        Search
        <IconButton
          aria-label='close search panel'
          color='inherit'
          edge='start'
          onClick={handleClose}
        >
          <CloseOutlined />
        </IconButton>
      </SearchDialogTitle>
      <DialogContent>
        <SearchBar />
      </DialogContent>
    </Dialog>
  );
};
